App.TagsFilterComponent = Em.Component.extend
  store: Em.inject.service('store')
  session: Em.inject.service('session')
  classNames: ['tags-filter']
  clientTags: null
  selectedTags: null

  isEdit: false

  actions:    
    onAddAndCreateTag: (tagName) ->
      props =  
        name: tagName
        organization: @get('session.currentOrganization')
      if @get('session.isLC')
        delete props.organization
        props.logistics_center = @get('session.currentLogisticsCenter')

      tag = @get('store').createRecord 'client_tag', props
      tag.save()

    toggleIsEdit: ->
      @toggleProperty('isEdit')

    onCheck: (tag) ->
      selectedTags  = @get('selectedTags')
      id            = tag.get('id')
      index         = selectedTags.indexOf(id)

      if index > -1
        selectedTags.removeAt(index)
      else
        selectedTags.pushObject(id)
